// import {IActionRedux, IPageState} from 'src/types/appStateInterface';
import { IActionRedux, IPageState } from "../../types/appStateInterface";
import { PAGE_ACTION } from "../actions/pageAction";

export const pageReducer = (
  state: IPageState,
  action: IActionRedux
): IPageState => {
  const { type, payload } = action;
  switch (type) {
    case PAGE_ACTION.SHOW_LOADER:
      return { ...state, loading: true };
    case PAGE_ACTION.HIDE_LOADER:
      return { ...state, loading: false };
    case PAGE_ACTION.CHANGE_LOADER_MESSAGE:
      return { ...state, loadingMessage: payload.message };
    case PAGE_ACTION.RESET_LOADER_MESSAGE:
      return { ...state, loadingMessage: undefined };
    case PAGE_ACTION.SHOW_SNACKBAR:
      return {
        ...state,
        snackbarShow: true,
        snackbarMessage: payload.message,
        snackbarSeverity: payload.severity,
      };
    case PAGE_ACTION.HIDE_SNACKBAR:
      return { ...state, snackbarShow: false, snackbarMessage: "" };
    default:
      return state;
  }
};
